import bankCodes from './components/bank-codes'
import banks from './pages/banks'
import certCenter from './pages/cert-center'
import certificates from './pages/certificates'
import changeStatusPopup from './components/popup/change-status-popup'
import clientAccount from './components/popup/client-account-popup'
import clientFilterPopup from './components/popup/client-filter-popup'
import dialog from '@/languages/ko-kr/dialog'
import errors from './errors'
import home from './pages/home'
import invoices from './pages/invoices'
import layout from './layout'
import notice from './pages/notice'
import password from './pages/password'
import signUp from './pages/sign-up/index'
import subsidy from './pages/subsidy'
import taxrefund from './pages/taxrefund'
import tax from './pages/tax'
import taxStatus from './tax-status'
import taxes from './pages/taxes'
import terms from './terms'
import user from './pages/user'
import userActions from './user-actions'

export default {
  terms,
  errors,
  userActions: userActions,
  pages: {
    'sign-up': signUp,
    'certificates': certificates,
    'taxes': taxes,
    'banks': banks,
    'tax': tax,
    'password': password,
    'user': user,
    'cert-center': certCenter,
    'invoices': invoices,
    'home': home,
    'notice': notice,
    'subsidy': subsidy,
    'taxrefund': taxrefund,
  },
  components: {
    'bank-codes': bankCodes,
    popup: {
      'client-filter-popup': clientFilterPopup,
      'change-status-popup': changeStatusPopup,
      'client-account': clientAccount,
      'taxrefund-contact-popup': taxrefund,
    },
  },
  layout,
  dialog,
  taxStatus,
}
